<template>
  <main class="app-main identity-stats-page">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ listTitle }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ listTitle }}</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <div v-if="showStats" class="row mt-4 g-2">
          <div class="col-xl-2 col-md-4 col-sm-6" v-for="(config, statusKey) in statConfigs" :key="statusKey">
            <div 
              class="stat-card" 
              @click="getByStatus(statusKey)"
              :class="['stat-' + statusKey]"
            >
              <div class="stat-card-content">
                <div class="stat-icon">
                  <i :class="config.icon"></i>
                </div>
                <div class="stat-info">
                  <span class="stat-label">{{ config.label }}</span>
                  <span class="stat-number">{{ stats[statusKey] || 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--begin::Row-->
        <div v-if="showCreateActions && checkAccess('property_create')" class="row mt-4">
          <div class="col text-end">
            <router-link :to="{path: '/properties/create', query: searchProjectId ? {projectId: searchProjectId} : {}}" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة عقار
            </router-link>
            <router-link to="/properties/createById" class="btn btn-success ms-3">
              <i class="bi bi-plus-circle me-1"></i> إضافة عقار برقم الترخيص
            </router-link>
          </div>
        </div>

        <!-- hidden for now waiting checkAccess -->
        <!-- <div v-if="!archived" class="row mt-3">
          <div class="col text-end">
            <router-link to="/properties/archive" class="btn btn-outline-secondary btn-sm">
              <i class="bi bi-archive me-1"></i> أرشيف العقارات
            </router-link>
          </div>
        </div> -->

        <!--FILTER-->
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <select v-model="searchCategory" class="form-control">
                      <option :value="null">تصنيف العقار</option>
                      <option v-for="(val, key) in categoriesChoices" :value="key" :key="key">{{ val }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select v-model="searchPurpose" class="form-control">
                      <option :value="null">الغرض من الإعلان</option>
                      <option v-for="(val, key) in purposeChoices" :value="key" :key="key">{{ val }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select v-model="searchPropertyType" class="form-control">
                      <option :value="null">نوع الساكن</option>
                      <option value="singles">عزاب</option>
                      <option value="families">عوائل</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select ref="statusSelect" v-model="searchStatus" class="form-control">
                      <!-- <option :value="null">حالة الإعلان</option> -->
                      <option v-for="(val, key) in statusTranslate" :value="key" :key="key">{{ val }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchMobile" class="form-control" placeholder="جوال العميل">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchOwnerContactMobile" class="form-control" placeholder="جوال المالك / الوكيل / الوسيط">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchAdvertiserId" class="form-control" placeholder="الرقم الموحد للمنشأة">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchAdLicense" class="form-control" placeholder="رقم الترخيص الإعلاني">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchBillboardNumber" class="form-control" placeholder="رقم اللوحة الإعلانية">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <label class="form-label">تاريخ تجديد العقد الإلكتروني</label>
                    <input type="date" v-model="searchRegaContractRenewalDate" class="form-control">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <label class="form-label">تاريخ تجديد عقد إدارة الأملاك</label>
                    <input type="date" v-model="searchManagementContractRenewalDate" class="form-control">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchRegion" @change="getCitiesList">
                      <option :value="null">المنطقة</option>
                      <option v-for="r in regionsList" :value="r.id" :key="r.id">{{ r.name }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select ref="citiesSelect" class="form-control" v-model="searchCity" @change="getNeighborhoodsList">
                      <option :value="null">المدينة</option>
                      <option v-for="r in citiesList" :value="r.id" :key="r.id">{{ r.name }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3 position-relative">
                    <div class="position-relative" ref="neighborhoodDropdown">
                      <button
                        type="button"
                        class="form-control text-end d-flex justify-content-between align-items-center px-3 py-2"
                        @click="searchCity && toggleNeighborhoodDropdown()"
                        :disabled="!searchCity"
                        :class="{ 'bg-light text-muted': !searchCity }"
                        style="cursor:pointer;"
                      >
                        <span class="text-truncate">
                          {{
                            !searchCity
                              ? 'الحي'
                              : (
                                  searchNeighborhood
                                    ? (neighborhoodsList.find(n => n.id == searchNeighborhood) || {}).name || 'الحي'
                                    : 'الحي'
                                )
                          }}
                        </span>
                        <i
                          :class="neighborhoodDropdownOpen ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"
                          class="ms-1 flex-shrink-0"
                        ></i>
                      </button>
                      <div
                        v-show="neighborhoodDropdownOpen"
                        class="position-absolute w-100 bg-white border rounded shadow-sm mt-1 p-2"
                        style="z-index:1050; top:100%;"
                      >
                        <div class="pb-2 border-bottom mb-2">
                          <input
                            ref="neighborhoodSearchInput"
                            type="text"
                            class="form-control form-control-sm"
                            v-model="neighborhoodSearch"
                            placeholder="بحث في الأحياء..."
                            @click.stop
                            @keydown.esc="neighborhoodDropdownOpen = false"
                          >
                        </div>
                        <div style="max-height:220px; overflow-y:auto;" class="px-1">
                          <a
                            class="dropdown-item py-2 rounded"
                            href="#"
                            @click.prevent="selectNeighborhood(null)"
                          >
                            <i class="bi bi-x-circle me-1 text-muted"></i>
                            الكل
                          </a>
                          <a
                            v-for="n in filteredNeighborhoods"
                            :key="n.id"
                            class="dropdown-item py-2 px-3 rounded mb-1"
                            :class="{ 'active bg-primary text-white': searchNeighborhood == n.id }"
                            href="#"
                            @click.prevent="selectNeighborhood(n.id)"
                          >
                            {{ n.name }}
                          </a>
                          <div
                            v-if="filteredNeighborhoods.length === 0"
                            class="text-muted text-center py-3 small"
                          >
                            لا توجد نتائج
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="string" v-model="searchPropertyId" class="form-control" placeholder="رقم العقار">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select ref="propertyTypeSelect" class="form-control" aria-label="نوع العقار">
                      <option value=""></option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select v-model="searchManagementType" class="form-control" aria-label="نوع الإدارة / التسويق">
                      <option :value="null">كل أنواع الإدارة / التسويق</option>
                      <option v-for="(label, value) in managementTypeChoices" :key="value" :value="value">{{ label }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <div class="form-check mt-2">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        v-model="searchLateRent"
                        :value="true"
                        id="lateRent"
                      >
                      <label class="form-check-label" for="lateRent">
                        إظهار الإيجارات المتأخرة
                      </label>
                    </div>
                    </div>
                  </div>    
                </div>
                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ الإنشاء</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button> 
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button> 
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">{{ listTitle }}</div>
                <span v-if="countRows > 0"
                  class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                  عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الصورة</th>
                            <th>الوصف</th>
                            <th>النوع</th>
                            <th>المدينة / الحي</th>
                            <th>المشاهدات</th>
                            <th>الحالة</th>
                            <th>تاريخ الإنشاء</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>
                              <router-link v-if="row.mediaFiles && row.mediaFiles.length" :to="propertyDetailsRoute(row.id)">
                                <img :src="MEDIA_URL+row.mediaFiles[0].thumbnail" class="img-thumbnail" style="max-width: 150px;" alt="">
                              </router-link>
                            </td>
                            <td>
                              <router-link :to="propertyDetailsRoute(row.id)">{{ row.title }}</router-link>
                            </td>
                            <td>{{ row.PropertyType.name }}</td>
                            <td>{{ [row.City?.name, row.Neighborhood?.name].filter(Boolean).join(' - ') || '—' }}</td>
                            <td>{{ row.views }}</td>
                            <td>{{ statusTranslate[row.status] }}</td>
                            <td>{{ $shortDate(row.createdAt) }}</td>
                            <td>
                              <router-link :to="propertyDetailsRoute(row.id)" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('property_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button
                                v-if="archived && checkAccess('property_update')"
                                class="btn btn-success btn-sm"
                                title="استرجاع من الأرشيف"
                                @click="restoreProperty(row.id, indx)"
                              ><i class="bi bi-arrow-counterclockwise"></i></button>
                              <button
                                v-else-if="!archived && checkAccess('property_update')"
                                class="btn btn-outline-secondary btn-sm"
                                title="أرشفة العقار"
                                @click="archiveProperty(row.id, indx)"
                              ><i class="bi bi-archive"></i></button>
                              <button v-if="!archived && checkAccess('property_delete')" class="btn btn-danger btn-sm ms-2" @click="deleteProperty(row.id, indx)"><i class="bi bi-trash"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, checkAccess } from '@/helpers/tools';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'PropertiesList',
  props: {
    advertiserIds: {
      type: Array,
      default: () => [],
    },
    showCreateActions: {
      type: Boolean,
      default: true,
    },
    showStats: {
      type: Boolean,
      default: true,
    },
    listTitle: {
      type: String,
      default: 'العقارات',
    },
    detailsQuery: {
      type: Object,
      default: () => ({}),
    },
    archived: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      searchProjectId: this.$route.query.projectId || null,
      pages: [],
      statusTranslate: {},
      categoriesChoices: {},
      purposeChoices: {},
      regionsList: [],
      citiesList: [],
      searchCategory: this.$route.query.category || null,
      searchPurpose: this.$route.query.purpose || null,
      searchPropertyType: this.$route.query.propertyType || null,
      searchStatus: this.$route.query.status || null,
      searchMobile: this.$route.query.mobile || '',
      searchOwnerContactMobile: this.$route.query.ownerContactMobile || '',
      searchRegion: this.$route.query.region || null,
      searchCity: this.$route.query.city || null,
      searchAdLicense: this.$route.query.adLicense || '',
      searchNeighborhood: this.$route.query.neighborhood || null,
      neighborhoodsList: [],
      neighborhoodSearch: '',
      neighborhoodDropdownOpen: false,
      stats: {
        available: 0,
        under_review: 0,
        sold: 0,
        rented: 0,
        reserved: 0,
        rejected: 0,
        stopped: 0,
      },
      showDateFilter: false,
      searchLateRent: this.$route.query.lateRent === '1' || false,
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      countRows: 0,
      searchPropertyId: this.$route.query.propertyId || '',
      searchBillboardNumber: this.$route.query.billboardNumber || '',
      searchRegaContractRenewalDate: this.$route.query.regaContractRenewalDate || '',
      searchManagementContractRenewalDate: this.$route.query.managementContractRenewalDate || '',
      searchAdvertiserId: this.$route.query.advertiserId || '',
      managementTypeChoices: {},
      searchTypeId: this.$route.query.typeId || null,
      searchTypeName: this.$route.query.typeName || '',
      searchManagementType: this.$route.query.managementType || null,
    }
  },

  computed:{
    ...mapGetters(['MEDIA_URL']),
    filteredNeighborhoods(){
      if(!this.neighborhoodSearch || !this.neighborhoodSearch.trim()) return this.neighborhoodsList;
      const q = this.neighborhoodSearch.trim().toLowerCase();
      return this.neighborhoodsList.filter(n => n.name && n.name.toLowerCase().includes(q));
    },
    statConfigs() {
    return {
      available: { 
        label: 'متاح', 
        icon: 'bi bi-check-circle-fill' 
      },
      under_review: { 
        label: 'تحت المراجعة', 
        icon: 'bi bi-clock-fill' 
      },
      sold: { 
        label: 'مباع', 
        icon: 'bi bi-cash-stack' 
      },
      rented: { 
        label: 'مؤجر', 
        icon: 'bi bi-house-door-fill' 
      },
      reserved: { 
        label: 'محجوز', 
        icon: 'bi bi-bookmark-check-fill' 
      },
      rejected: { 
        label: 'مرفوض', 
        icon: 'bi bi-x-circle-fill' 
      },
      stopped: { 
        label: 'إيقاف من الهيئة', 
        icon: 'bi bi-exclamation-triangle-fill' 
      }
    };
    },
  },
  methods: {
    checkAccess,

    propertyDetailsRoute(id){
      return {path: `/properties/update/${id}`, query: this.detailsQuery};
    },

    getStats(){
      if(!this.showStats)
        return;
      this.$http.get('/api/admin/properties/dashboardStats')
        .then(({data}) => {
          this.stats = data.stats;
        })
        .catch(() => {});
    },

    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let urlQuery = [`page=${this.currentPage}`];
      if(this.searchProjectId)
        urlQuery.push(`projectId=${encodeURIComponent(this.searchProjectId)}`);
      if(this.searchCategory)
        urlQuery.push(`category=${this.searchCategory}`);
      if(this.searchPurpose)
        urlQuery.push(`purpose=${this.searchPurpose}`);
      if(this.searchPropertyType)
        urlQuery.push(`propertyType=${this.searchPropertyType}`);
      if(this.searchStatus)
        urlQuery.push(`status=${this.searchStatus}`);
      if(this.searchMobile.trim() != '')
        urlQuery.push(`mobile=${this.searchMobile.trim()}`);
      if(this.searchOwnerContactMobile.trim() != '')
        urlQuery.push(`ownerContactMobile=${encodeURIComponent(this.searchOwnerContactMobile.trim())}`);
      if(this.searchRegion)
        urlQuery.push(`regionId=${this.searchRegion}`);
      if(this.searchCity)
        urlQuery.push(`cityId=${this.searchCity}`);
      if(this.searchAdLicense.trim() != '')
        urlQuery.push(`adLicenseNumber=${this.searchAdLicense.trim()}`);
      if(this.searchNeighborhood)
        urlQuery.push(`neighborhoodId=${this.searchNeighborhood}`);
      if(this.searchLateRent)
        urlQuery.push('lateRent=1');
      if(this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);
      if(this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);
      if(this.searchPropertyId !== '' && this.searchPropertyId !== null)
        urlQuery.push(`propertyId=${this.searchPropertyId}`);
      if(this.searchBillboardNumber.trim() != '')
        urlQuery.push(`billboardNumber=${this.searchBillboardNumber.trim()}`);
      if(this.searchRegaContractRenewalDate)
        urlQuery.push(`regaContractRenewalDate=${this.searchRegaContractRenewalDate}`);
      if(this.searchManagementContractRenewalDate)
        urlQuery.push(`managementContractRenewalDate=${this.searchManagementContractRenewalDate}`);
      if(this.searchAdvertiserId.trim() != '')
        urlQuery.push(`advertiserId=${encodeURIComponent(this.searchAdvertiserId.trim())}`);
      if(this.advertiserIds.length)
        urlQuery.push(`advertiserIds=${encodeURIComponent(this.advertiserIds.join(','))}`);
      if(this.searchTypeId) 
        urlQuery.push(`typeId=${encodeURIComponent(this.searchTypeId)}`);
      if(this.searchManagementType !== null) 
        urlQuery.push(`managementType=${encodeURIComponent(this.searchManagementType)}`);
      if(this.archived)
        urlQuery.push('archived=1');
      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchProjectId ? {projectId: this.searchProjectId} : {}),
        ...(this.searchCategory !== null && this.searchCategory !== '' && this.searchCategory !== false ? { category: this.searchCategory } : {}),
        ...(this.searchPurpose !== null && this.searchPurpose !== '' && this.searchPurpose !== false ? { purpose: this.searchPurpose } : {}),
        ...(this.searchPropertyType !== null && this.searchPropertyType !== '' && this.searchPropertyType !== false ? { propertyType: this.searchPropertyType } : {}),
        ...(this.searchStatus !== null && this.searchStatus !== '' && this.searchStatus !== false ? { status: this.searchStatus } : {}),
        ...(this.searchMobile !== null && this.searchMobile !== '' && this.searchMobile !== false ? { mobile: this.searchMobile } : {}),
        ...(this.searchOwnerContactMobile !== null && this.searchOwnerContactMobile !== '' && this.searchOwnerContactMobile !== false ? { ownerContactMobile: this.searchOwnerContactMobile } : {}),
        ...(this.searchRegion !== null && this.searchRegion !== '' && this.searchRegion !== false ? { region: this.searchRegion } : {}),
        ...(this.searchCity !== null && this.searchCity !== '' && this.searchCity !== false ? { city: this.searchCity } : {}),
        ...(this.searchAdLicense !== null && this.searchAdLicense !== '' && this.searchAdLicense !== false ? { adLicense: this.searchAdLicense } : {}),
        ...(this.searchNeighborhood !== null && this.searchNeighborhood !== '' && this.searchNeighborhood !== false ? { neighborhood: this.searchNeighborhood } : {}),
        ...(this.searchLateRent ? { lateRent: '1' } : {}),
        ...(this.searchDateFrom !== null && this.searchDateFrom !== '' && this.searchDateFrom !== false ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo !== null && this.searchDateTo !== '' && this.searchDateTo !== false ? { dateTo: this.searchDateTo } : {}),
        ...(this.searchPropertyId !== null && this.searchPropertyId !== '' && this.searchPropertyId !== false ? { propertyId: this.searchPropertyId } : {}),
        ...(this.searchBillboardNumber !== null && this.searchBillboardNumber !== '' && this.searchBillboardNumber !== false ? { billboardNumber: this.searchBillboardNumber } : {}),
        ...(this.searchRegaContractRenewalDate ? { regaContractRenewalDate: this.searchRegaContractRenewalDate } : {}),
        ...(this.searchManagementContractRenewalDate ? { managementContractRenewalDate: this.searchManagementContractRenewalDate } : {}),
        ...(this.searchAdvertiserId.trim() ? { advertiserId: this.searchAdvertiserId.trim() } : {}),
        ...(this.searchTypeId ? {typeId: this.searchTypeId, typeName: this.searchTypeName} : {}),
        ...(this.searchManagementType !== null ? {managementType: this.searchManagementType} : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/properties/list?${urlQuery.join('&')}`).then(({data}) => {
        this.rows = data.properties;
        this.statusTranslate = data.statusChoices;
        this.categoriesChoices = data.propertyCategoriesChoices;
        this.purposeChoices = data.propertyPurposeChoices;
        this.regionsList = data.regionsList;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.managementTypeChoices = data.propertyManagementTypeChoices || {};
        this.mainLoading = false;
        this.$nextTick(() => {
          this.applySelect2Status();
        });
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },

    deleteProperty(id, index){
      this.$swal.fire({
        title: "هل تريد تأكيد حذف العقار ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/api/admin/properties/delete/${id}`).then(({data}) => {
            let buffer = this.rows;
            buffer.splice(index, 1);
            this.rows = buffer;
            toast('تم حذف العقار بنجاح', 'success');
          }).catch(err => {
            toast('غير قادر على حذف العقار');
          });
        }
      });
    },

    archiveProperty(id, index){
      this.$swal.fire({
        title: 'هل تريد أرشفة هذا العقار؟',
        text: 'لن يظهر العقار في القائمة الرئيسية ويمكن استرجاعه لاحقاً من الأرشيف.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'أرشفة',
        cancelButtonText: 'إلغاء',
        confirmButtonColor: '#6c757d',
      }).then((result) => {
        if (!result.isConfirmed) return;
        this.$http.put(`/api/admin/properties/archive/${id}`).then(() => {
          this.rows.splice(index, 1);
          this.countRows = Math.max(0, this.countRows - 1);
          toast('تم أرشفة العقار بنجاح', 'success');
        }).catch(() => toast('تعذر أرشفة العقار'));
      });
    },

    restoreProperty(id, index){
      this.$swal.fire({
        title: 'هل تريد استرجاع هذا العقار؟',
        text: 'سيعود العقار إلى قائمة العقارات الرئيسية.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'استرجاع',
        cancelButtonText: 'إلغاء',
        confirmButtonColor: '#198754',
      }).then((result) => {
        if (!result.isConfirmed) return;
        this.$http.put(`/api/admin/properties/restore/${id}`).then(() => {
          this.rows.splice(index, 1);
          this.countRows = Math.max(0, this.countRows - 1);
          toast('تم استرجاع العقار بنجاح', 'success');
        }).catch(() => toast('تعذر استرجاع العقار'));
      });
    },

    getCitiesList(){
      this.citiesList = [];
      this.searchCity = null;
      this.neighborhoodsList = [];
      this.searchNeighborhood = null;
      this.neighborhoodDropdownOpen = false;
      if(!this.searchRegion){
        return;
      }
      this.$http.get(`/api/admin/cities/list?regionId=${this.searchRegion}&all=1`).then(({data}) => {
        this.citiesList = data.cities;
      }).catch(() => {});
    },

    getNeighborhoodsList(){
      this.neighborhoodsList = [];
      this.searchNeighborhood = null;
      this.neighborhoodSearch = '';
      this.neighborhoodDropdownOpen = false;
      if(!this.searchCity){
        return;
      }
      this.$http.get(`/api/admin/neighborhoods/list?cityId=${this.searchCity}&all=1`).then(({data}) => {
        this.neighborhoodsList = data.neighborhoods || [];
      }).catch(() => {});
    },

    toggleNeighborhoodDropdown(){
      this.neighborhoodDropdownOpen = !this.neighborhoodDropdownOpen;
      if(this.neighborhoodDropdownOpen){
        this.$nextTick(() => {
          if(this.$refs.neighborhoodSearchInput)
            this.$refs.neighborhoodSearchInput.focus();
        });
      }
    },

    selectNeighborhood(id){
      this.searchNeighborhood = id;
      this.neighborhoodDropdownOpen = false;
      this.neighborhoodSearch = '';
    },

    getByStatus(statusNeeded){
      this.currentPage = 1;
      this.searchStatus = statusNeeded;
      this.getList();
    },

    nextPage(){
      this.currentPage += 1;
      this.getList();
    },

    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },

    goToPage(num){
      this.currentPage = num;
      this.getList();
    },

    filterSubmit(){
      this.currentPage = 1;
      this.getList();
    },

    clearFilter(){
      this.currentPage = 1;
      this.searchProjectId = null;
      this.searchCategory = null;
      this.searchPurpose = null;
      this.searchPropertyType = null;
      this.searchStatus = null;
      this.searchMobile = '';
      this.searchOwnerContactMobile = '';
      this.searchRegion = null;
      this.searchCity = null;
      this.searchLateRent = false;
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.searchAdLicense = '';
      this.searchNeighborhood = null;
      this.neighborhoodsList = [];
      this.neighborhoodSearch = '';
      this.neighborhoodDropdownOpen = false;
      this.searchPropertyId = '';
      this.searchBillboardNumber = '';
      this.searchRegaContractRenewalDate = '';
      this.searchManagementContractRenewalDate = '';
      this.searchAdvertiserId = '';
      this.searchTypeId = null;
      this.searchTypeName = '';
      this.searchManagementType = null;
      $(this.$refs.propertyTypeSelect).val(null).trigger('change.select2');
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },
    applySelect2Cities(){
      if(!this.$refs.citiesSelect){
        setTimeout(() => this.applySelect2Cities(), 200);
        return;
      }
      const myInstance = this;
      const $el = $(this.$refs.citiesSelect);
      if ($el.hasClass('select2-hidden-accessible')){
        $el.off('change.citiesSelect2');
        $el.select2('destroy');
      }
      $el.select2({ width: '100%' })
        .on('change.citiesSelect2', function () {
          const newVal = $(this).val() || null;
          if(newVal === myInstance.searchCity) return;
          myInstance.searchCity = newVal;
          myInstance.getNeighborhoodsList(); 
        });
    },
    applySelect2Status(){
      if(!this.$refs.statusSelect){
        setTimeout(() => this.applySelect2Status(), 200);
        return;
      }
      const myInstance = this;
      const $el = $(this.$refs.statusSelect);
      if($el.hasClass('select2-hidden-accessible')){
        $el.off('change.statusSelect2');
        $el.select2('destroy');
      }
      $el.select2({ width: '100%', placeholder: 'حالة الإعلان'});
      $el.val(this.searchStatus).trigger('change.select2');
      $el.on('change.statusSelect2', function(){
        myInstance.searchStatus = $(this).val() || null;
      });
    },
    applySelect2PropertyTypes(){
      const $el = $(this.$refs.propertyTypeSelect);
      const instance = this;
      $el.select2({
        width: '100%', dir: 'rtl', placeholder: 'نوع العقار', allowClear: true,
        ajax: {
          delay: 250,
          transport(params, success, failure) {
            let aborted = false;
            instance.$http.get('/api/admin/propertyTypes/search', {params: params.data})
              .then(({data}) => { if (!aborted) success(data); })
              .catch(err => { if (!aborted) failure(err); });
            return {abort() { aborted = true; }};
          },
          data: params => ({q: params.term || '', page: params.page || 1}),
          processResults: data => ({results: data.results, pagination: data.pagination}),
        },
      });
      if (this.searchTypeId) {
        $el.append(new Option(this.searchTypeName || `نوع العقار #${this.searchTypeId}`, this.searchTypeId, true, true));
        $el.trigger('change.select2');
      }
      $el.on('change.propertyTypes', function() {
        instance.searchTypeId = $(this).val() || null;
        instance.searchTypeName = instance.searchTypeId ? $(this).find(':selected').text() : '';
      });
    },
  },

  mounted(){
    this._clickOutsideHandler = (e) => {
      if(this.$refs.neighborhoodDropdown && !this.$refs.neighborhoodDropdown.contains(e.target)){
        this.neighborhoodDropdownOpen = false;
      }
    };
    document.addEventListener('click', this._clickOutsideHandler);
    this.applySelect2Cities();
    this.applySelect2Status();
    this.applySelect2PropertyTypes();
  },

  beforeUnmount(){
    if(this._clickOutsideHandler)
      document.removeEventListener('click', this._clickOutsideHandler);
    const $types = $(this.$refs.propertyTypeSelect);
    $types.off('.propertyTypes');
    if ($types.hasClass('select2-hidden-accessible')) $types.select2('destroy');
  },

  created(){
    this.getList();
    this.getStats();
  }
}
</script>

<style scoped>
.stat-card {
  background: white;
  border-radius: 10px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
  min-height: 70px;
  display: flex;
  align-items: center;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.08);
  border-color: transparent;
}

.stat-card-content {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.stat-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.stat-card:hover .stat-icon {
  transform: scale(1.05);
}

.stat-info {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.stat-label {
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
}

.stat-number {
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
}

.stat-available .stat-icon { 
  color: #4CAF50; 
  background: rgba(76, 175, 80, 0.12); 
}
.stat-available .stat-number { color: #4CAF50; }
.stat-available:hover { border-color: #4CAF50; background: #fafdfa; }

.stat-under_review .stat-icon { 
  color: #FFA726; 
  background: rgba(255, 167, 38, 0.12); 
}
.stat-under_review .stat-number { color: #FFA726; }
.stat-under_review:hover { border-color: #FFA726; background: #fffcf5; }

.stat-sold .stat-icon { 
  color: #080c09; 
  background: rgba(67, 160, 71, 0.12); 
}
.stat-sold .stat-number { color: #080c09; }
.stat-sold:hover { border-color: #080c09; background: #fafdfa; }

.stat-rented .stat-icon { 
  color: #29B6F6; 
  background: rgba(41, 182, 246, 0.12); 
}
.stat-rented .stat-number { color: #29B6F6; }
.stat-rented:hover { border-color: #29B6F6; background: #f5faff; }

.stat-reserved .stat-icon { 
  color: #5C6BC0; 
  background: rgba(92, 107, 192, 0.12); 
}
.stat-reserved .stat-number { color: #5C6BC0; }
.stat-reserved:hover { border-color: #5C6BC0; background: #f8f9ff; }

.stat-rejected .stat-icon { 
  color: #EF5350; 
  background: rgba(239, 83, 80, 0.12); 
}
.stat-rejected .stat-number { color: #EF5350; }
.stat-rejected:hover { border-color: #EF5350; background: #fdf8f8; }

.stat-stopped .stat-icon { 
  color: #e4201a; 
  background: rgba(255, 111, 0, 0.12); 
}
.stat-stopped .stat-number { color: #e4201a; }
.stat-stopped:hover { border-color: #e4201a; background: #fffcf5; }
</style>